// CRM 2.0 virtual account texts (M6-F8; rows M6.14 / M6.26 / M6.35; DC-96 / DC-113 / DC-114). Only for a customer
// with a CRM 2.0 booking (old-flow-only customers keep today's screens):
//   - closed: a red "Virtual Account Closed" banner instead of the account number / IFSC / beneficiary
//   - open: "One account for your CUID. Used now for: <units>. It closes only when no unit needs it."
// Data from GET /crm2/portal/va (status, units still using it, hasCrm2).
import React, { useEffect, useState } from "react";
import { getCrm2VaStatus } from "../../../Services/Crm2Portal";

export function useCrm2Va() {
	const [va, setVa] = useState(null);
	useEffect(() => {
		let live = true;
		getCrm2VaStatus()
			.then((d) => live && setVa(d || null))
			.catch((err) => console.error("[crm2][useCrm2Va] VA status failed", { error: err?.response?.data?.message || err?.message }));
		return () => {
			live = false;
		};
	}, []);
	return va;
}

export function VaClosedBanner() {
	return (
		<div style={{ border: "1px solid #FECDCA", background: "#FEF3F2", color: "#B42318", borderRadius: "0.8rem", padding: "1.2rem 1.4rem", fontSize: "1.4rem", lineHeight: "2rem" }}>
			<b style={{ display: "block", fontSize: "1.5rem" }}>Virtual Account Closed</b>
			Do not transfer to this account. Pay any balance into the RERA accounts.
		</div>
	);
}

export function VaUsedFor({ va }) {
	if (!va?.hasCrm2 || va.status !== "ACTIVE") return null;
	return (
		<p style={{ fontSize: "1.3rem", color: "#475467", margin: "1rem 0 0", lineHeight: "1.9rem" }}>
			One account for your CUID.{va.usedBy?.length ? ` Used now for: ${va.usedBy.join(", ")}.` : ""} It closes only when no unit needs it.
		</p>
	);
}
